import "../Style/appdevstack.css";

import androidImg from "../assets/android.png";
import dartImg from "../assets/dart.png";
import firebaseImg from "../assets/firebase.png";
import flutterImg from "../assets/flutter.png";
import githubImg from "../assets/github.png";
import kotlinImg from "../assets/kotlin.png";
import vscodeImg from "../assets/vscode.png";
import postmanImg from "../assets/postman.png";

/* VALUE BOX ICONS */
import commitmentImg from "../assets/commitment.png";
import excellenceImg from "../assets/excellence.png";
import passionImg from "../assets/passion.png";
import priorityImg from "../assets/priority.png";

const tools = [
  { src: kotlinImg, alt: "Kotlin" },
  { src: vscodeImg, alt: "VS Code" },
  { src: postmanImg, alt: "Postman" },
  { src: androidImg, alt: "Android" },
  { src: githubImg, alt: "GitHub" },
  { src: firebaseImg, alt: "Firebase" },
  { src: flutterImg, alt: "Flutter" },
  { src: dartImg, alt: "Dart" },
];

export default function AppdevStack() {
  const items = [...tools, ...tools];

  return (
    <section className="appdevstack-stack-section">
      <div className="appdevstack-stack-pattern" aria-hidden="true" />

      <div className="appdevstack-stack-inner">
        <div className="appdevstack-stack-badge">
          <div className="appdevstack-stack-badge-ring" aria-hidden="true" />
          <h2 className="appdevstack-stack-badge-title">Technology Stack</h2>
          <span className="appdevstack-stack-badge-subtitle">
            Mobile App Development Tools
          </span>
        </div>

        <div className="appdevstack-stack-right">
          <span className="appdevstack-stack-eyebrow">
            Tools &amp; Technology
          </span>

          <h3 className="appdevstack-stack-info-heading">
            Modern Mobile App Development Technology Stack
          </h3>

          <p className="appdevstack-stack-info-desc">
            At MPeoples, we leverage industry-leading frameworks, programming
            languages, cloud platforms, and development tools to build
            secure, scalable, and high-performance mobile applications for
            startups, enterprises, and growing businesses.
          </p>

          <div className="appdevstack-stack-marquee-card">
            <div className="appdevstack-stack-marquee-outer">
              <div className="appdevstack-stack-marquee-track">
                {items.map((tool, i) => (
                  <div className="appdevstack-stack-cell" key={i}>
                    <div className="appdevstack-stack-icon-wrap">
                      <img
                        src={tool.src}
                        alt={tool.alt}
                        className="appdevstack-stack-icon"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BLUE VALUE BOX */}
      <div className="appdevstack-value-wrapper">
        <div className="appdevstack-value-box">
          <div className="appdevstack-value-card">
            <img
              src={commitmentImg}
              alt="Commitment"
              className="appdevstack-value-image"
            />
            <h4 className="appdevstack-value-title">Commitment</h4>
            <p className="appdevstack-value-desc">
              We are committed to delivering reliable, scalable, and
              high-quality mobile applications that help businesses achieve
              measurable growth and long-term success.
            </p>
          </div>

          <div className="appdevstack-value-card">
            <img
              src={excellenceImg}
              alt="Excellence"
              className="appdevstack-value-image"
            />
            <h4 className="appdevstack-value-title">Excellence</h4>
            <p className="appdevstack-value-desc">
              Our development process follows industry best practices, clean
              coding standards, and rigorous quality assurance to ensure
              exceptional application performance.
            </p>
          </div>

          <div className="appdevstack-value-card">
            <img
              src={passionImg}
              alt="Innovation"
              className="appdevstack-value-image"
            />
            <h4 className="appdevstack-value-title">Innovation</h4>
            <p className="appdevstack-value-desc">
              We embrace modern technologies, creative problem-solving, and
              continuous improvement to build innovative mobile applications
              that stay ahead of market trends.
            </p>
          </div>

          <div className="appdevstack-value-card">
            <img
              src={priorityImg}
              alt="Customer First"
              className="appdevstack-value-image"
            />
            <h4 className="appdevstack-value-title">Customer First</h4>
            <p className="appdevstack-value-desc">
              Every mobile application is designed around your business
              goals, user expectations, and long-term success. Your
              satisfaction remains our highest priority throughout the
              development journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}